import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightActivity',
})
export class HighlightActivityPipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/(in progress|fully paid|disputed|received[ \$0-9.,]*)/i, "<b>$1</b>");
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/highlight-activity.pipe.ts